"use client";
import React, { ReactElement } from "react";
import dayjs from "dayjs";
import { Review as IReview } from "@/app/me/[slug]/Mentor/Mentor.schema";
import Image from "next/image";
import styles from "./Review.module.css";
import StarRating from "../../atoms/StarRating";
const FallbackAvatar = "/images/avatar-placeholder.gif";

const Review = ({
  rating,
  reviewer,
  comment,
  created_at,
}: IReview): ReactElement => {
  // const formatDateTime = (dateTime: string): string => {
  //   return dayjs(dateTime).format("MMMM YYYY");
  // };
  return (
    <div className={styles.container}>
      <div className={styles.user}>
        <div className={styles.avatar}>
          <Image
            src={reviewer.avatarImage || FallbackAvatar}
            alt={`avatar ${reviewer.name}`}
            width={40}
            height={40}
          />
        </div>
        <p>{reviewer.name}</p>
      </div>
      <div className={styles.rating}>
        <StarRating rating={rating} />
        {/* <span>{formatDateTime(created_at)}</span> */}
      </div>

      <p className={styles.comment}>{comment}</p>
    </div>
  );
};

export default Review;
